export default __webpack_public_path__ + "static/personalTraining-2ee93d7ced6bab07dea9d77d4eec9794.png";